// theme/src/gift-wrap/src/packaging/components/ChooseBoxStep.jsx
import React from 'react';
import { useGiftWrapContext } from '../../context/GiftWrapContext';
import { usePackaging } from '../PackagingContext';
import { plainVariant } from '../buildChoices';
import { getBoxCopy } from '../copy';
import { OptionCard } from './OptionCard';
import styles from '../packaging.module.css';

export function ChooseBoxStep() {
  const { selection, dispatch, groups, stepState } = usePackaging();
  const { setGiftInfo } = useGiftWrapContext();

  return (
    <div role="radiogroup" aria-label="Choose your box" className={styles.cards}>
      {stepState.boxOptions.map((role) => {
        const option = groups[role];
        const copy = getBoxCopy(role);
        const price = plainVariant(option)?.price ?? 0;
        return (
          <OptionCard
            key={role}
            name={copy.name}
            description={copy.description}
            badge={copy.badge}
            priceNote={copy.priceNote}
            price={price}
            heroImages={role === 'luxe' ? [option.imageUrl] : []}
            thumbUrl={option.imageUrl}
            selected={selection.box === role}
            onSelect={() => dispatch({ type: 'selectBox', box: role })}
            onInfo={() => setGiftInfo({ title: option.title, price, imageUrl: option.imageUrl, description: option.description })}
          />
        );
      })}
    </div>
  );
}
